import axios from "axios";
import Cookies from "js-cookie";

const baseurl = process.env.REACT_APP_API_BASE_URL;
const token = Cookies.get("token");
export const APICall = async (
  url,
  method,
  data = null,
  responseType = "json",
) => {
  try {
    const response = await axios({
      url,
      method,
      data,
      baseURL: baseurl,
      responseType, // 'json' by default, can be 'blob' for file downloads
      headers: {
        Authorization: token,
        ...(data && typeof data === "object" && !(data instanceof FormData)
          ? { "Content-Type": "application/json" }
          : {}),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const APICallWithImage = async (url, method, data) => {
  try {
    const response = await axios({
      url,
      method,
      data,
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
      baseURL: baseurl,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
